import { useContext } from 'react';
import { assign } from 'xstate';
import { useInterpret } from '@xstate/react';
import { DataAccessContext } from '@chargify/data-access';

import { GlobalStateContext } from '../contexts';
import {
  reactivateSubscription,
  SetErrorEvent,
} from '../machines/reactivateSubscription';
import { ReactivateSubscriptionDoneEvent } from '../machines/reactivateSubscription/types';

export const useReactivateSubscription = (
  catalogId: number,
  subscriptionId: number
) => {
  const { dataAccess } = useContext(DataAccessContext);
  const { subscriptionsService } = useContext(GlobalStateContext);
  return useInterpret(reactivateSubscription, {
    services: {
      reactivateSubscription: () => {
        return dataAccess.reactivateSubscription(subscriptionId);
      },
    },
    actions: {
      updateSubscription: (
        _ctx,
        {
          data: {
            nextAssessmentAt,
            currentBillingAmountInCents,
            currentPeriodEndsAt,
          },
        }: ReactivateSubscriptionDoneEvent
      ) => {
        subscriptionsService.send({
          type: 'UPDATE_SUBSCRIPTION',
          catalogId,
          subscriptionId,
          nextAssessmentAt,
          currentPeriodEndsAt,
          currentBillingAmountInCents,
          scheduledCancellationAt: null,
          status: 'active',
        });
      },
      setError: assign((context, event: SetErrorEvent) => {
        return {
          ...context,
          error: event.data,
        };
      }),
    },
  });
};
